<script>
    import { createEventDispatcher } from "svelte";
    import { navigate } from "svelte-routing";
    import { timestampToDate } from "../../utils/utils";
    import Fa from "svelte-fa";
    import { faArrowRight, faPen, faTrash } from "@fortawesome/free-solid-svg-icons";
    import ViewRewards from "./ViewRewards.svelte";
    import Button from "../ui/Button.svelte";
    import Toggle from "../ui/Toggle.svelte";
    import Help from "../ui/Help.svelte";
    import ViewMilestones from "./ViewMilestones.svelte";

    export let card;
    $: editable = card.state=="archived"?false:true;

    const dispatch = createEventDispatcher();

    function remove() {
        dispatch("remove", {
            id: card.id
        })
    }

    function setAutoRenewal(e) {
        dispatch("setAutoRenewal", {
            id: card.id,
            data: {
                autoRenewal: e.detail
            }
        });
    }

    function edit() {
        navigate("/stempelkarten/"+card.id);
    }

    function open (e) {
        if(e.target.tagName == "BUTTON" || e.target.tagName == "LABEL") {
            return
        }
        if(!editable) {
            return
        }
        edit();
    }
</script>



<div class="container {card.state}" class:editable={editable} on:click={open}>
    <div class="datespan">
        <span>{card.start?timestampToDate(card.start):"undefined"}</span>
        <span>-</span>
        <span>{card.end?timestampToDate(card.end, -1):"offen"}</span>
    </div>
    <div class="card-info">
        <div class="header">
            <div class="title">
                <h2>{card.name??"Unbenannte Stempelkarte"}</h2>
                <span class="state">{card.state=="active"?"Aktiv":card.state=="scheduled"?"Geplant":card.state=="archived"?"Abgelaufen":"Unvollständig"}</span>
            </div>
            <div class="actions">
                {#if card.state != "archived"}
                    <Button transparent on:click={edit}>
                        <Fa
                            slot="icon"
                            icon={faPen}
                        />
                    </Button>
                {/if}
                {#if !card.handedOut || card.handedOut == 0}
                    <Button transparent on:click={remove}>
                        <Fa
                            slot="icon"
                            icon={faTrash}
                        />
                    </Button>
                {/if}
            </div>
        </div>
        <div class="content">
            <div class="milestones">
                {#if card?.milestones}
                    <ViewMilestones bind:milestones={card.milestones}></ViewMilestones>
                {:else}
                    <span>keine Belohnungen eingetragen</span>
                {/if}
            </div>
            {#if card.state == "active" || card.state == "archived"}
            <div class="stats">
                <table>
                    <tr>
                        <th>Herausgegeben</th>
                        <td>{card.handedOut??0} Karten</td>
                    </tr>
                    <tr>
                        <th>Eingelöst</th>
                        <td>{card.redeemed??0} Karten</td>
                    </tr>
                </table>
            </div>
            {/if}
            <div class="auto-renewal">
                <div class="auto-renew">
                    <Toggle size="s" bind:checked={card.autoRenewal} on:change={setAutoRenewal} disabled={card.state=="archived"}>
                        Karte automatisch verlängern
                    </Toggle>
                    <Help>
                        Wenn diese Option aktiv ist, wird vor dem Ablaufen der Karte das Ende immer wieder um eine Woche verlängert. Dies geschieht solange bis eine andere Karte beginnt, oder du die Option deaktivierst.
                    </Help>
                </div>
            </div>
        </div>
    </div>
</div>

<style>
    .container {
        display: flex;
        justify-content: space-between;
        border-radius: 0.5rem;
        color: #333;
        gap: 1.5rem;
        flex-wrap: wrap;
        background-color: #F5F2EF;
    }
    
    .container.archived {
        filter: grayscale(1);
    }
    
    .container.active {
        background-color: rgba(180, 230, 170, 0.2);
    }
    
    .container.incomplete {
        background-color: rgba(255, 228, 140, 0.2);
    }

    .container.editable {
        cursor: pointer;
        transition: border-radius 150ms cubic-bezier(0.3, 0.1, 0.25, 1.4);
    }
    
    .container.editable:hover {
        border-radius: 20px;
        background-color: #ebe6e2;
    }
    
    .container.editable.active:hover {
        background-color: #e7f4e4;
        background-color: #dcecd8;
        background-color: rgba(180, 230, 170, 0.4);
    }

    .container.editable.incomplete:hover {
        background-color: #fffae8;
        background-color: rgba(255, 228, 140, 0.4);
    }

    .datespan {
        padding: 1rem;
        flex-basis: 7ch;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        /* font-size: 1.25rem; */
        /* line-height: 1; */
        border-right: 2px solid #E0D8D2;
    }

    .active .datespan {
        border-right: 2px solid rgb(180, 230, 170);
    }

    .card-info {
        flex: 1;
        padding: 1rem;
        display: flex;
        gap: 0.5rem;
        flex-direction: column;
    }

    .header {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        gap: 1rem;
    }

    .title {
        display: flex;
        align-items: center;
        gap: 0.7rem;
        line-break: strict;
        text-overflow: ellipsis;
    }

    .actions {
        margin-top: -0.25rem;
    }

    .content {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 1.5rem;
        /* margin-bottom: 1rem; */
    }

    .milestones {
        display: flex;
        flex-direction: column;
    }

    .stats table {
        min-width: 50%;
        border-spacing: 0;
    }

    .stats th {
        font-weight: normal;
        text-align: left;
    }

    .stats td {
        font-weight: normal;
        text-align: right;
    }

    .state {
        font-size: 0.8rem;
        padding: 0.2rem 0.4rem;
        border-radius: 0.5rem;
        display: inline-block;
        background-color: rgb(255, 228, 140);
        color: #8b4513;
    }
    
    .scheduled .state{        
        background-color: #E0D8D2;
        color: rgb(117, 107, 100);
    }

    .active .state{        
        background-color: rgb(180, 230, 170);
        color: rgb(0, 60, 3);
    }

    .archived .state {        
        background-color: rgb(210, 210, 210);
        color: rgb(30, 30, 30);
    }

    h2 {
        margin: 0;
        line-height: 1;
    }

    .arrow {
        display: inline-block;
        margin-inline-start: 0.5rem;
        margin-inline-end: 0.5rem;
        color: #E0D8D2;
    }

    
    .active .arrow {
        color: rgb(180, 230, 170);
    }
    
    .repeat {
        display: inline-block;
        /* margin-inline-start: 0.5rem; */
        margin-inline-end: 0.5rem;
        color: #E0D8D2;
    }
    
    .active .repeat {
        color: rgb(180, 230, 170);
    }

    .auto-renew {
        display: flex;
        align-items: center;
    }
</style>